'use client'

import BugsnagPerformance from '@bugsnag/browser-performance'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import { useEffect } from 'react'

type BugsnagBrowserClientProps = {
	apiKey?: string
	appType: string
	appVersion: string
	releaseStage: string
	enabledReleaseStages: string[]
}

type BugsnagPerformanceClientProps = {
	apiKey?: string
	appVersion: string
	releaseStage: string
	enabledReleaseStages: string[]
}

/**
 * Initializes Bugsnag in browser.
 *
 * @see https://docs.bugsnag.com/platforms/javascript/configuration-options/#available-options
 */
export function BugsnagBrowserClient({
	appType,
	apiKey,
	appVersion,
	releaseStage,
	enabledReleaseStages,
}: BugsnagBrowserClientProps) {
	// biome-ignore lint/correctness/useExhaustiveDependencies: we do not expect to change any props during runtime for bugsnag
	useEffect(() => {
		if (!apiKey) {
			return
		}

		const client = Bugsnag.start({
			appType,
			apiKey,
			appVersion,
			releaseStage,
			enabledReleaseStages,
			plugins: [new BugsnagPluginReact()],
		})

		client.leaveBreadcrumb('Application has started. (Client)')
	}, [])

	return null
}

/**
 * Initializes Bugsnag performance monitoring
 */
export function BugsnagPerformanceClient({
	apiKey,
	appVersion,
	releaseStage,
	enabledReleaseStages,
}: BugsnagPerformanceClientProps) {
	// biome-ignore lint/correctness/useExhaustiveDependencies: we do not expect to change any props during runtime for bugsnag
	useEffect(() => {
		if (!apiKey) {
			return
		}

		BugsnagPerformance.start({
			apiKey,
			appVersion,
			releaseStage,
			enabledReleaseStages,
		})
	}, [])

	return null
}
